import httpAuth from "@/common/http/http-common";
import { SmsFormDto } from "@/types/sms.type";

class SmsService {
  client = httpAuth("sms");

  async createReferMessageAsync(form: SmsFormDto): Promise<void> {
    await this.client.put("refer", form);
  }
}

export default new SmsService();